export enum DrawerType {
  Mobile = 0,
  Computer = 1,
}

export enum ReceiptStatus {
  PENDING = 'Canhoto pendente',
  WAITING_APPROVAL = 'Canhoto aguardando aprovação',
  APPROVED = 'Canhoto aprovado',
  REJECTED = 'Canhoto rejeitado',
}

export enum PaymentOrderStatus {
  READY_FOR_ISSUANCE = 'Nota fiscal pendente',
  ISSUED = 'Nota fiscal emitida',
  PAID = 'Pago',
  CANCELED = 'Cancelada',
}

export enum DeliveryStatus {
  ALL = 'Todos',
  WAITING_FOR_PICK_UP = 'Aguardando coleta', // The package is ready for pick up
  LOADING = 'Carregando', // The package is being loaded on the truck
  IN_TRANSIT = 'Em andamento', // The package is on the truck and is being delivered
  LOADED = 'Carregado', // The package has been loaded on the truck
  ARRIVED_DELIVERY_ADDRESS = 'O motorista chegou ao endereço de entrega', // The truck has arrived at the delivery address
  DELIVERED = 'Entregue', // The package has been delivered successfully
  RETRYING_DELIVERY = 'Tentativa de entrega', // The package is being delivered again
  RETURNING_TO_ORIGIN = 'Retornando ao remetente', // The package is being returned to origin
  RETURNED = 'Retornado', // The package has been returned to origin after failed delivery
  PROBLEM_REPORTED = 'Com Problema', // There was a problem reported during the delivery
  REPROCESSED = 'Reprocessado', // The delivery was reprocessed
  CANCELLED = 'Cancelado', // The delivery was cancelled
  AWAITING_DRIVER_ASSIGNMENT = 'Aguardando atribuição de motorista', // The delivery is awaiting a driver assignment
  PENDING = 'Canhoto pendente', // The receipt was reproved
}

export enum FreightStatus {
  ALL = 'Todos',
  AWAITING_DRIVER_ACCEPTANCE = 'Aguardando aceitação do motorista',
  AWAITING_DRIVER_ASSIGNMENT = 'Aguardando atribuição de motorista',
  READY_FOR_PICKUP = 'Pronto para coleta',
  LOADING = 'Carregando',
  LOADED = 'Carregado',
  ENROUTE_TO_DESTINATION = 'A caminho do destino',
  DELIVERY_IN_PROGRESS = 'Entrega em progresso', // aguardando
  RETURNING_TO_ORIGIN = 'Retornando ao ponto de origem',
  COMPLETED = 'Concluído',
  CANCELLED = 'Cancelado', // Distributor cancelled the freight
  PROBLEM_REPORTED = 'Problema reportado',
  PENDING = 'Pendente',
}

export enum CartStatus {
  ALL = 'Todos',
  REJECTED_RECEIPT = 'Canhoto Rejeitado',
  // Cart is waiting for a freight
  WAITING_FREIGHT = 'Aguardando Frete',
  ARRIVED_DELIVERY_ADDRESS = 'O motorista chegou ao endereço de entrega',

  // Cart is waiting for a driver
  WAITING_TO_LOAD = 'Aguardando Carregamento',
  AWAITING_DRIVER_ASSIGNMENT = 'Aguardando Atribuição de Motorista',
  // Cart is on the way to the origin
  RETURNING_TO_ORIGIN = 'Retornando ao Destinatário',
  // Cart is on delivery
  ON_DELIVERY = 'Em Entrega',
  // Cart is cancelled
  CANCELLED = 'Cancelado',
  // Cart is returned reestocking
  RETURNED = 'Retornado',
  // Cart is delivered
  DELIVERED = 'Entregue',
  PROBLEM_REPORTED = 'Problema Reportado',
  LOADED = 'Carregado',
}
